module.exports = __webpack_public_path__ + "static/img/reChangJing4.16ca946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reChangJing4.png
// module id = IEfB
// module chunks = 2